import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";

import { ConfigProvider } from "./contexts/ConfigContext";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./routes/ProtectedRoute";

import MarketingLayout from "./layouts/MarketingLayout";
import AppLayout from "./layouts/AppLayout";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import SetPassword from "./pages/SetPassword";
import Signup from "./pages/Signup";
import RequestAccess from "./pages/RequestAccess";
import Dashboard from "./pages/Dashboard";
import Shipments from "./pages/Shipments";
import PreparingChecklist from "./pages/PreparingChecklist";
import ShipmentResults from "./pages/ShipmentResults";
import DocumentChecklist from "./pages/DocumentChecklist";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import Admin from "./pages/Admin";

function App() {
  return (
    <BrowserRouter>
      <ConfigProvider>
        <AuthProvider>
          <Routes>
            <Route element={<MarketingLayout />}>
              <Route path="/" element={<Landing />} />
              <Route path="/request-access" element={<RequestAccess />} />
            </Route>

            <Route path="/login" element={<Login />} />
            <Route path="/set-password" element={<SetPassword />} />
            <Route path="/signup" element={<Signup />} />

            <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/shipments" element={<Shipments />} />
              <Route path="/shipments/:shipmentId/preparing-checklist" element={<PreparingChecklist />} />
              <Route path="/shipments/:id" element={<ShipmentResults />} />
              <Route path="/checklists" element={<DocumentChecklist />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/settings" element={<Settings />} />
            </Route>

            <Route element={<ProtectedRoute requireSuperAdmin><AppLayout /></ProtectedRoute>}>
              <Route path="/admin" element={<Admin />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Analytics />
        </AuthProvider>
      </ConfigProvider>
    </BrowserRouter>
  );
}

export default App;
